import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    this.#bindShowAll();
  }

  #bindShowAll() {
    const button = this.querySelector('[data-blog-show-all]');
    if (!button) return;

    button.addEventListener('click', () => {
      const hiddenPosts = this.querySelectorAll('[data-blog-extra-post]');
      for (const post of hiddenPosts) {
        post.removeAttribute('hidden');
      }
      button.closest('.blog-posts__show-all')?.remove();
    });
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}